<template>
<v-dialog v-model="show" max-width="600">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on"></slot>
  </template>
  <v-card>
    <CardTitle :title="editing ? 'Edit Hubspot ID' : 'Add Hubspot ID'"></CardTitle>
    <v-card-text>
      <v-text-field v-model="form.hubspot_company_id" label="Hubspot ID"></v-text-field>
      <v-autocomplete
          v-if="name"
          label="Hubspot companies"
          persistent-hint
          hint="This runs a quick search on hubspot for this company name. Selecting one finds the company id for you."
          v-model="selectedCompany"
          :loading="loadingCompanies"
          :disabled="loadingCompanies"
          :items="companies"
          item-text="name"
          item-value="id"
          @change="form.hubspot_company_id = selectedCompany"
      >
      </v-autocomplete>
    </v-card-text>
    <CardActions @close="show = false" @submit="submit"></CardActions>
  </v-card>
</v-dialog>
</template>

<script>
import Hubspot from "@/Lib/Hubspot";

export default {
    name: "Hubspot",
    components: {},
    data: () => ({
      show: false,
      loading: false,
      loadingCompanies: false,
      form: {
        hubspot_company_id: null,
      },
      companies: [],
      selectedCompany: null,
    }),
    props:{
      customer_id: {
        required: true,
      },
      hubspot_id: {
        required: false,
      },
      name: {
        required: false,
      },
      editing: {
        default: false,
        type: Boolean,
        required: false,
      }
    },
    mounted(){
      if(this.editing){
        this.form.hubspot_company_id = this.hubspot_id;
      }
      if(this.name){
        this.loadHubspotCompanies()
      }
    },
    methods: {
      async loadHubspotCompanies(){
        this.loadingCompanies = true;
        try{
          let companies = await Hubspot.post('/companies/search', {
            filters: [
              {
                propertyName: 'name',
                operator: 'EQ',
                value: this.name
              }
            ]
          })
          console.log(companies)
          this.companies = companies.data.results.map(company => {
            return {
              id: company.id,
              ...company.properties,
            }
          })
        }catch(e){
          console.log(e)
        }finally{
          this.loadingCompanies = false;
        }
      },
      async submit(){
        try{
          this.loading =true;
          await this.$store.$db().model('customers').api().save({
            id: this.customer_id,
            ...this.form
          })
          await this.$store.dispatch("showSuccess", "Updated Customer!")
        }catch(e){
          console.log(e)
          await this.$store.dispatch("showError", "Failed to update customer")
        }finally{
          this.loading = false;
        }
        this.show = false
      }
    }
}
</script>

<style scoped>

</style>